import React, { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import Spinner from "./Spinner";

const SectionLoadingLogo: React.FC = () => {
  const [isShowing, setIsShowing] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsShowing((previous) => !previous);
    }, 850);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      className="relative flex min-h-[12rem] items-center justify-center py-10"
      aria-busy="true"
      aria-live="polite"
    >
      <Transition
        show={isShowing}
        enter="transform transition duration-[1600ms]"
        enterFrom="opacity-100 rotate-[-360deg] scale-50"
        enterTo="opacity-100 rotate-0 scale-80"
        leave="transform transition ease-in-out"
        leaveFrom="opacity-100 rotate-0 scale-100"
        leaveTo="opacity-100 scale-50 duration-[800ms]"
      >
        <div className="flex items-center justify-center">
          <Spinner />
        </div>
      </Transition>
      <span className="sr-only">Loading search results</span>
    </div>
  );
};

export default SectionLoadingLogo;
